export default {"src":"/_next/static/media/0x9a71012b13ca4d3d0cdc72a177df3ef03b0e76a3.525f9ff9.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};